import React, { Component } from 'react';
import { Row, Button, message } from 'antd';
import { Link } from 'dva/router';

import { connect } from 'dva';
import styles from './index.less';
@connect(({ user }) => ({
  user: user.currentUser,
}))
class EmailNotVerified extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  resendVerificationEmail = () => {
    const { dispatch } = this.props;
    dispatch({
      type: 'user/sendVerificationEmail',
      force: true,
    });
  };

  render() {
    return (
      <div style={{ marginTop: '10%' }}>
        <Row type="flex" justify="space-around" align="middle">
          <div style={{ textAlign: 'center' }}>
            <div>
              <img src="/emailnotverified.png" alt="noCustomRegulation" height="200px" />
            </div>
          </div>
        </Row>
      </div>
    );
  }
}

export default EmailNotVerified;
